import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  
  @Input() visibleBurger;
  @Input() showLogoImage;
  @Input() textLogo;
  @Input() logoClick;
  @Input() logoUrl;
  @Input() imageUrl;
  @Input() menuTabs;
  @Input() shoppingCart;
  @Input() visibleBack;
  @Input() visibleLogin;
  @Input() visibleVideoCall;
  @Input() visibleRegister;
  @Input() backRoute;

  constructor(private router: Router) { }

  ngOnInit(): void {
    if(!this.showLogoImage){
      this.showLogoImage = true;
    }
    if(this.logoClick == undefined){
      this.logoClick = true;
    }
    if(!this.textLogo){
      this.textLogo = 'default';
    }
    if(!this.shoppingCart){
      this.shoppingCart = false;
    }
    if(!this.visibleBack){
      this.visibleBack = false;
      this.backRoute = null;
    }
    
    if(!this.menuTabs){
      this.menuTabs = [
        {
          name: 'Inicio',
          path: 'home',
          htmlId: '',
          enabled: true
        },
        {
          name: 'Servicios',
          path: 'services',
          htmlId: '#servicesSection',
          enabled: true
        },
        {
          name: 'Nosotros',
          path: 'about',
          htmlId: '#aboutUs',
          enabled: false
        },
        {
          name: 'FAQ',
          path: 'faqs',
          htmlId: '#faqs',
          enabled: true
        },
        {
          name: 'Asistencia en Europa',
          path: 'home',
          htmlId: '#asistenciaEuropa',
          enabled: false
        },
        {
          name: 'Blog',
          path: 'blog',
          htmlId: '#blog',
          enabled: true
        },
        {
          name: 'Términos y condiciones',
          path: '/terms',
          htmlId: '',
          enabled: true
        },
        {
          name: 'Testimonios',
          path: '/services/#testimoniosSection',
          htmlId: '#testimoniosSection',
          enabled: false
        },
        {
          name: 'Contacto',
          path: 'contact',
          htmlId: '#contactSection',
          enabled: true
        },
        {
          name: 'Dashboard',
          /* path: 'dashboard/'+this.rootScope.getCurrentToken(), */
          htmlId: '',
          enabled: this.isAdminLoggedIn()
        }
      ]
    }
    if(!this.imageUrl){
      this.imageUrl = '../assets/images/logos/logoSmall.png';
    }
    if(!this.logoUrl){
      this.logoUrl = 'https://voyjaleas.com';
    }
  }

  goToHomePage() {
    if(this.logoClick){
      window.open(this.logoUrl, '_blank');
    }
  }

  goToCovid19Page() {
    this.router.navigateByUrl('/covid19#title-section');
  }

  goToPage(page: any) {
    this.router.navigateByUrl(page.path);
  }

  goBack(){
    this.router.navigateByUrl(this.backRoute);
  }

  isAdminLoggedIn(){
    /* return this.rootScope.getIsAdminLoggedIn(); */
    return false;
  }

  loginScreen(){
    /* window.open('https://app.voyjaleas.com/login', '_blank'); */
  }

  registerScreen(){
    let page = {path: 'register'};
    this.goToPage(page);
  }

  goToCalendly(){
    window.open('https://calendly.com/voy-jaleas/30min?month=2023-02', '_blank');
  }

}